import { styled } from "@mui/material";

export const PaginationWrapper = styled("ul")`
	list-style: none;

	button {
		height: 32px;
	}
`;
